import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {AppService} from '@app/app.service';
import {FieldConfig} from '../field.interface';
import {FormGroup} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {MY_FORMATS} from '../day-month/day-month.component';
import {Subscription} from 'rxjs';
import {getLanguage} from '@app/core/main.module';
import * as moment from 'moment';

@Component({
    selector: 'app-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.css', '../input/input.scss'],
    providers: [
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
        {provide: MAT_DATE_LOCALE, deps: [AppService], useFactory: getLanguage},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
    ]
})
export class DateRangeDDMMComponent implements OnInit, OnDestroy {
    field: FieldConfig;
    group: FormGroup;
    data: any;
    max = null;
    min = null;
    getMax$: Subscription;
    getMin$: Subscription;
    dataFilter = (d: Date): boolean => {
        if (!this.max && !this.min) {
            return true;
        }
        if (!this.max && this.min) {
            return this.min <= d;
        }
        if (this.max && !this.min) {
            return this.max >= d;
        }
        if (this.max && this.min) {
            return this.max >= d >= this.min;
        }
    };

    constructor(public appService: AppService) {
    }

    ngOnInit() {
        this.getMax();
        this.getMin();
        if (this.data && this.data.maxField && this.group.get(this.data.maxField)) {
            this.getMax$ = this.group.get(this.data.maxField).valueChanges.subscribe(() => {
                this.getMax();
            });
        }
        if (this.data && this.data.minField && this.group.get(this.data.minField)) {
            this.getMin$ = this.group.get(this.data.minField).valueChanges.subscribe(() => {
                this.getMin();
            });
        }
        if (this.field.disabled) {
            setTimeout(() => {
                this.group.get(this.field.name + '_min').disable({onlySelf: true, emitEvent: false});
                this.group.get(this.field.name + '_max').disable({onlySelf: true, emitEvent: false});
            });
        }
    }

    ngOnDestroy() {
        this.getMin$?.unsubscribe();
        this.getMax$?.unsubscribe();
    }

    /**
     * Получение максимального ограничения
     */
    getMax() {
        if (this.data && this.data.maxDate) {
            this.max = this.data.maxDate;
        } else if (this.data && this.data.maxField && this.group.get(this.data.maxField)) {
            if (typeof this.group.get(this.data.maxField).value == 'string') {
                this.max = moment(this.group.get(this.data.maxField).value);
            } else {
                this.max = this.group.get(this.data.maxField).value;
            }
        } else {
            this.max = null;
        }
    }

    /**
     * Получение минимального ограничения
     */
    getMin() {
        if (this.data && this.data.minDate) {
            this.min = this.data.minDate;
        } else if (this.data && this.data.minField && this.group.get(this.data.minField)) {
            if (typeof this.group.get(this.data.minField).value == 'string') {
                this.min = moment(this.group.get(this.data.minField).value);
            } else {
                this.min = this.group.get(this.data.minField).value;
            }
        } else {
            this.min = null;
        }
    }

    /**
     * Изменение даты
     */
    changeEvent() {
        let ctrlValueMin = this.group.get(this.field.name + '_min').value
            ? this.group.get(this.field.name + '_min').value
            : moment().hour(0).minute(0).second(0)
                .add(moment().utcOffset(), 'm').utc(false);
        if (typeof ctrlValueMin == 'string') {
            ctrlValueMin = moment(ctrlValueMin, 'DD.MM.YYYY').hour(0).minute(0).second(0)
                .add(moment().utcOffset(), 'm').utc(false);
        }
        this.group.get(this.field.name + '_min').setValue(moment([
            ctrlValueMin.year(), ctrlValueMin.month(), ctrlValueMin.date()
        ]).add(ctrlValueMin.utcOffset(), 'm').utc(false));

        let ctrlValueMax = this.group.get(this.field.name + '_max').value
            ? this.group.get(this.field.name + '_max').value
            : moment().hour(0).minute(0).second(0)
                .add(moment().utcOffset(), 'm').utc(false);
        if (typeof ctrlValueMax == 'string') {
            ctrlValueMax = moment(ctrlValueMax, 'DD.MM.YYYY').hour(0).minute(0).second(0)
                .add(moment().utcOffset(), 'm').utc(false);
        }
        this.group.get(this.field.name + '_max').setValue(moment([
            ctrlValueMax.year(), ctrlValueMax.month(), ctrlValueMax.date()
        ]).add(ctrlValueMax.utcOffset(), 'm').utc(false));
    }
}
